import { useMutation } from '@tanstack/react-query';
import { SpreadsheetDefinition } from 'common/types/summaryDefinitions';
import SummaryDefinitionsService, { AIAssistResponse } from 'services/summaryDefinitions';

interface AIAssistParams {
  prompt: string;
  current_definition: SpreadsheetDefinition;
}

export const useAIAssistSummary = (firmId: number) => {
  const service = new SummaryDefinitionsService();

  return useMutation<AIAssistResponse, Error, AIAssistParams>({
    mutationFn: data => service.aiAssistFirmDefinition(firmId, data),
  });
};
